import axios from "axios";
import { url, token } from "./Config";
import { ResponseValidation } from "./Functions";
import Cookies from "js-cookie";
import { isSessionExpired, expireSession } from "./sessionManager";

// In-flight GET request deduplication map to prevent multiple parallel API calls
const pendingGetRequests = new Map();

const getAuthHeaders = (headers) => {
  if (headers && typeof headers === "object" && Object.keys(headers).length > 0) {
    return headers;
  }
  if (isSessionExpired()) {
    expireSession();
    return { Authorization: "" };
  }
  let currentToken = "";
  try {
    const cookie = Cookies.getJSON("foodoor_token");
    if (cookie && cookie.token) {
      currentToken = cookie.token;
    }
  } catch (e) {}
  return { Authorization: currentToken };
};

export const GET_API = async (headers, params, path) => {
  // Normalize parameters and construct a clean deduplication key
  const cleanParams = params ? String(params).trim() : "";
  const dedupeKey = `${path}?${cleanParams}`;

  // If an identical GET request is already in-flight, return the existing promise
  if (pendingGetRequests.has(dedupeKey)) {
    return pendingGetRequests.get(dedupeKey);
  }

  const fetchPromise = (async () => {
    const authHeaders = getAuthHeaders(headers);

    const timestamp = Date.now();
    let requestUrl;
    if (cleanParams !== "") {
      requestUrl = `${url}${path}${path.includes("?") ? "&" : "?"}cache_remove=${timestamp}&${cleanParams}`;
    } else {
      requestUrl = `${url}${path}${path.includes("?") ? "&" : "?"}cache_remove=${timestamp}`;
    }

    const config = {
      method: "get",
      url: requestUrl,
      headers: authHeaders,
    };

    let response = await axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (error.response) {
          return error.response;
        } else {
          return { status: 503, message: "Assumming Server is not running" };
        }
      });

    return ResponseValidation(response);
  })().finally(() => {
    // Keep in pending map briefly to catch simultaneous/burst calls (e.g. StrictMode, duplicate mounts)
    setTimeout(() => {
      pendingGetRequests.delete(dedupeKey);
    }, 300);
  });

  pendingGetRequests.set(dedupeKey, fetchPromise);
  return fetchPromise;
};

export const POST_API = async (data, headers, path) => {
  // showMessage("Post", "info", "post", "top", "top-right", 3000) //shabeeb change

  const authHeaders = getAuthHeaders(headers);

  var config = {
    method: "post",
    url: url + path,
    headers: authHeaders,
    data: data,
  };

  let response = await axios(config)
    .then(function (response) {
      //showMessage(JSON.stringify(response), "success", "post", "top", "top-right", 3000)
      // void 0
      return response;
    })
    .catch(function (error) {
      //showMessage(JSON.stringify(error), "danger", "post", "top", "top-right", 3000)
      // void 0
      if (error.response) {
        // void 0
        // void 0
        // void 0
        return error.response;
      } else {
        // void 0
        return { status: 503 };
      }
    });
  return ResponseValidation(response);
};

export const PATCH_API = async (data, headers, path) => {
  const authHeaders = getAuthHeaders(headers);

  var config = {
    method: "patch",
    url: url + path,
    headers: authHeaders,
    data: data,
  };
  // void 0
  let response = await axios(config)
    .then(function (response) {
      //showMessage(JSON.stringify(response), "success", "patch", "top", "top-center", 3000)
      // void 0
      // void 0
      return response;
    })
    .catch(function (error) {
      //showMessage(JSON.stringify(error), "danger", "patch", "top", "top-center", 3000)
      // void 0
      // void 0
      if (error.response) {
        // void 0
        // void 0
        // void 0
        return error.response;
      } else {
        // void 0
        return { status: 503 };
      }
    });
  return ResponseValidation(response);
};

export const PUT_API = async (data, headers, path, params) => {
  const authHeaders = getAuthHeaders(headers);

  var config = {
    method: "put",
    url: url + path,
    headers: authHeaders,
    data: data,
  };
  // void 0
  let response = await axios(config)
    .then(function (response) {
      //showMessage(JSON.stringify(response), "success", "put", "top", "top-center", 3000)
      // void 0
      // void 0
      return response;
    })
    .catch(function (error) {
      //showMessage(JSON.stringify(error), "danger", "post", "top", "top-center", 3000)
      // void 0
      // void 0
      if (error.response) {
        // void 0
        // void 0
        // void 0
        return error.response;
      } else {
        return { status: 503 };
      }
    });
  return ResponseValidation(response);
};

export const DELETE_API = async (headers, params, path) => {
  const authHeaders = getAuthHeaders(headers);

  var config = {
    method: "delete",
    url: url + path + "?" + params,
    headers: authHeaders,
  };

  let response = await axios(config)
    .then(function (response) {
      // void 0
      return response;
    })
    .catch(function (error) {
      // void 0
      // void 0
      // void 0
      if (error.response) {
        // void 0
        // void 0
        // void 0
        return error.response;
      } else {
        // void 0
        return { status: 503 };
      }
      // return []
    });

  return ResponseValidation(response);
};
